import { LOANREQUEST_BUCKETS } from 'cpool-constants';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class LoanRequest_Classified extends _Event {
    constructor(payload: EventSchema<LoanRequest_Classified>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            type: z.nativeEnum(LOANREQUEST_BUCKETS),
        });
    }

    static example(): EventSchema<LoanRequest_Classified> {
        return {
            type: LOANREQUEST_BUCKETS.PK,
        };
    }
}
